import { Directive, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

declare const $;
let _TEMP;

@Directive({
	selector: '[jvector-map]'
})
export class JvectorMapDirective implements OnInit, OnChanges {
	@Input() colors;
	@Input() label;
	@Input() refresh;
	@Input() map;
	@Input() dataset;
	// eslint-disable-next-line @angular-eslint/no-output-on-prefix
	@Output() onMapHover = new EventEmitter();

	constructor(private el: ElementRef) {
		const self = this;
		_TEMP = this;
		setTimeout(() => {
			self.createVectorMap();
		}, 1000);
	}

	ngOnChanges() {
		this.createVectorMap();
	}

	// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
	ngOnInit() {}

	createVectorMap() {
		$(this.el.nativeElement).html('');
		$(this.el.nativeElement).vectorMap({
			map: this.map,
			backgroundColor: '#fff',
			zoomOnScroll: true,
			regionStyle: {
				initial: {
					fill: '#fff',
					stroke: '#1d1d1d',
					'stroke-width': 0.2,
					'stroke-opacity': 1
				},
				hover: {
					'fill-opacity': 0.8
				},
				selected: {
					fill: '#8dc859'
				},
				selectedHover: {}
			},
			series: {
				regions: [
					{
						values: this.dataset,
						scale: this.colors,
						normalizeFunction: 'polynomial',
						legend: {
							vertical: true,
							title: this.label,
							labelRender: function (e) {
								return Math.max(parseInt(e), 1);
							}
						}
					}
				]
			},
			onRegionTipShow: function (event, label, code) {
				const amount = _TEMP.dataset[code] ? _TEMP.dataset[code] : 0;
				label.html('<strong>' + label.html() + ': </strong>' + amount);
			}
		});
	}
}
